import React from 'react';
import classNames from 'classnames';
import classes from './ImageRemover.module.css';
import { useImageRemover } from './ImageRemoverContext.jsx';

const IMAGE_URLS = [
    {
        url: '/assets/images/1.png',
        alt: 'a woman with an afro is looking at the camera by Good Faces'
      },
  {
    url: 'https://images.unsplash.com/photo-1632765854612-9b02b6ec2b15?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&dl=good-faces-xmSWVeGEnJw-unsplash.jpg&w=1920',
    alt: 'a woman with an afro is looking at the camera by Good Faces'
  },
  {
    url: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&dl=dom-hill-nimElTcTNyY-unsplash.jpg&w=1920',
    alt: 'woman in yellow tracksuit standing on basketball court side by Dom Hill'
  },
  {
    url: 'https://images.unsplash.com/photo-1628035514544-ebd32b766089?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&dl=kristian-angelo-KW-jwdSgOw4-unsplash.jpg&w=1920',
    alt: 'man in black leather jacket riding black motorcycle by Kristian Angelo'
  },
  {
    url: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&dl=pauline-loroy-U3aF7hgUSrk-unsplash.jpg&w=1920',
    alt: 'white and brown long coat large dog by Pauline Loroy'
  },
  {
    url: 'https://images.unsplash.com/photo-1540492649367-c8565a571e4b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&dl=andreas-m-p40QuGwGCcw-unsplash.jpg&w=1920',
    alt: 'green plant on yellow ceramic pot by Andreas M'
  }
];

function ImageRemover() {
  const {
    imageUrl,
    originalImageUrl,
    hasProcessedImage,
    isProcessing,
    processMessage,
    resetState,
    processImage,
    inferenceTime,
    imageType,
    fileType,
  } = useImageRemover();

  const [stopwatch, setStopwatch] = React.useState(0);
  const [isDragging, setIsDragging] = React.useState(false);
  const [compareView, setCompareView] = React.useState(false);

  const showUploadScreen = React.useMemo(() => {
    return !isProcessing && !hasProcessedImage;
  }, [isProcessing, hasProcessedImage]);

  React.useEffect(() => {
    let timerInstance;

    if (isProcessing) {
      timerInstance = setInterval(() => {
        setStopwatch((time) => time + 0.01);
      }, 10);
    } else {
      clearInterval(timerInstance);
      setStopwatch(0);
    }

    return () => clearInterval(timerInstance);
  }, [isProcessing, processMessage, isProcessing]);



  const download = ()=>{

    const link = document.createElement("a");
    // 생성한 a태그의 href를 blob URL로 지정해주고,
    link.href = imageUrl;
    // prop으로 받은 파일명을 지정해준다 (이 속성이 있어야 다운로드된다)
    link.download = 'bg-removed-image-download.' + imageType;
    // 링크요소를 클릭하여 동작하게 해준다.
    link.click();
  }

  const compareToggle =()=>{
    setCompareView(!compareView)
  }


  return (
    <div className={classes.block}>
      {hasProcessedImage && (
        <div className={"flex"}>
             <button onClick={() => resetState()} type="button" className="flex justify-center items-center gap-x-1.5 rounded-md bg-red-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600">
                  <div className="inline-flex">
                      <svg className="-ml-0.5 h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
                        </svg>
                        다시하기
                  </div>
            </button>
            <button onClick={() => compareToggle()} type="button" style={{marginLeft : "10px"}} className="flex justify-center items-center gap-x-1.5 rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                  <div className="inline-flex">
                      <svg className="-ml-0.5 h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
                      </svg>
                        {compareView ? "변환된 이미지만 보기" : "원본과 비교해서 보기"}
                  </div>
            </button>
        </div>
      )}

      <div
        className={classNames(classes.preview, {
          [classes.dragging]: isDragging
        })}
        onDragLeave={(e) => {
          if (!showUploadScreen) return;

          e.preventDefault();
          e.stopPropagation();
          setIsDragging(false);
        }}
        onDragEnter={(e) => {
          if (!showUploadScreen) return;

          e.preventDefault();
          e.stopPropagation();
          setIsDragging(true);
        }}
        onDragOver={(e) => {
          if (!showUploadScreen) return;

          e.preventDefault();
          e.stopPropagation();
          setIsDragging(true);
        }}
        onDrop={(e) => {
          if (!showUploadScreen) return;

          e.preventDefault();
          e.stopPropagation();
          setIsDragging(false);
          let draggedData = e.dataTransfer;
          let [file] = draggedData.files;
          
          fileType(file.type)

          const objectURL = URL.createObjectURL(file);

          processImage(objectURL);
        }}
      >
        {isProcessing && (
          <>
            <img
              className={classNames(classes.imagePreview, classes.blurred)}
              style={{
                opacity: 1
              }}
              src={originalImageUrl}
              alt={'Processed Image'}
            />
          </>
     

        )}

        {hasProcessedImage && (
          <>

          {compareView ? (
          <div className={"flex justify-center "}>
            <img
              className={classNames(classes.imagePreview)}
              style={{
                opacity: 1
              }}
              src={originalImageUrl}
              alt={'Uploaded Image'}
            />
            <div style={{width : "30px", height : "20px"}}></div>
            <img
              className={classNames(classes.imagePreview, {
                [classes.blurred]: isProcessing
              })}
              style={{
                opacity: 1
              }}
              src={imageUrl}
              alt={'Processed Image'}
            />
          </div> ) : 
            <img
              className={classNames(classes.imagePreview, {
                [classes.blurred]: isProcessing
              })}
              style={{
                opacity: 1
              }}
              src={imageUrl}
              alt={'Processed Image'}
            />
          }

            <button onClick={() => download()} type="button" className="flex justify-center items-center gap-x-1.5 rounded-md bg-green-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600">
                  <div className="inline-flex">
                      <svg className="-ml-0.5 h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
                        </svg>
                        배경제거 된 이미지 다운로드 받기
                  </div>
            </button>
          </>
        )}

        {!isProcessing && !hasProcessedImage && (
          <div className={classes.uploadControls}>
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M28.6993 8.48148L14.6992 20.4815L17.3024 23.5185L28.0009 14.3484V36.0005H32.0009V14.3485L42.6992 23.5185L45.3024 20.4815L31.3025 8.48149C30.5535 7.83951 29.4483 7.8395 28.6993 8.48148Z" fill="#161617" fillOpacity="0.65"/>
            <path opacity="0.75" d="M10 36V46C10 48.2091 11.7909 50 14 50H46C48.2091 50 50 48.2091 50 46V36" stroke="#161617" strokeOpacity="0.65" strokeWidth="4" strokeLinejoin="round"/>
            </svg>

            <label className={classes.upload}>
              이미지를 여기에 갖다 넣으세요
              <input
                className={classes.hidden}
                type="file"
                onChange={(event) => {
                  const [file] = event.target.files;
                  fileType(file.type)
                  const objectURL = URL.createObjectURL(file);
                  processImage(objectURL);
                }}
                accept="image/png, image/jpeg"
              />
            </label>
            <small className={classes.filetypeNotice}>PNG or JPEG</small>
          </div>
        )}

        {isProcessing && processMessage && (
          <div className={classes.processingOverlay}>
            <svg
            width="64"
            height="64"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
                d="M12.5 8C12.5 5.51472 10.4853 3.5 8 3.5C5.51472 3.5 3.5 5.51472 3.5 8C3.5 10.4853 5.51472 12.5 8 12.5"
                stroke="currentColor"
                strokeOpacity="0.9"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            </svg>

            <p className={classes.processMessage}>{processMessage}</p>
            {isProcessing && (
              <p className={classes.processStatus}>
                {stopwatch.toFixed(2) + 's'}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default React.memo(ImageRemover);
